module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"close":"Close","save":"Save","question":"Ask custom question","questionHint":"The maximum number of characters is 200","preview":"Preview"}}')
  delete Component.options._Ctor
}
